import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './Intro.scss'


const Intro = ({ image, line1, line2, line3, isVisible }) => {
  return (
    <CSSTransitionGroup
      transitionName='ou_intro'
      transitionEnterTimeout={1700}
      transitionLeaveTimeout={1500}
    >
      {isVisible && <div className='ou_scene ou_intro'>
        <div id='ou_intro__cropper-image-preview' className='ou_intro__cropper-image-preview' style={{display: 'none'}} />
        <div id='ou_intro__doors' className='ou_intro__doors' key='intro' >
          <div className='ou_intro__door-wrap ou_intro__door-wrap_left'>
            <div className='ou_intro__door ou_intro__door_left' style={{ backgroundImage: `url(${image})` }} />
          </div>
          <div className='ou_intro__door-wrap ou_intro__door-wrap_right'>
            <div className='ou_intro__door ou_intro__door_right' style={{ backgroundImage: `url(${image})` }} />
          </div>
        </div>
        <div id='ou_intro__content' className='ou_intro__content'>
          <span id='ou_intro__content-line_1' className='ou_intro__content-line ou_intro__content-line_1'>{line1}</span>
          <span id='ou_intro__content-line_2' className='ou_intro__content-line ou_intro__content-line_2'>{line2}</span>
          <span id='ou_intro__content-line_3' className='ou_intro__content-line ou_intro__content-line_3'>{line3}</span>
        </div>
      </div>}
    </CSSTransitionGroup>
  )
}

Intro.propTypes = {
  image: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line3: PropTypes.string,
  isVisible: PropTypes.bool,
}

export default Intro



// WEBPACK FOOTER //
// ./src/templates/outSide/components/scenes/Intro.js